import React from 'react'

const Bills = () => {
  return (
    <div>Bills</div>
  )
}

export default Bills